module.exports = __webpack_public_path__ + "static/media/b1.43f596e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengqingsheng/b1.mp3
// module id = vvDn
// module chunks = 0